import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosServicesService } from '@services/productos-services.service';
import { SeoService } from '@services/seo.service';
import { categoryPath, productId, productPath } from '@services/seo-url.util';
import { safeSessionStorage } from '@shared/safe-web-storage';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  public lsProdRec:any;
  public lsProdNov:any;
  public readonly faqItems = [
    {
      question: '¿Cuánto tarda el envío?',
      answer: 'El tiempo de entrega depende del destino y del servicio de paquetería disponible. Al confirmar tu compra te compartimos la información de envío y seguimiento de tu pedido.'
    },
    {
      question: '¿Los productos tienen garantía?',
      answer: 'Sí. Los productos cuentan con garantía contra defectos de fabricación conforme a las condiciones de cada marca o proveedor. Conserva tu comprobante de compra para cualquier aclaración.'
    },
    {
      question: '¿Puedo hacer cambios o devoluciones?',
      answer: 'Los cambios y devoluciones se revisan caso por caso. El producto debe conservarse en buenas condiciones, con empaque y accesorios completos. Contáctanos antes de enviar cualquier producto.'
    }
  ];
  private readonly categoryLinks: Record<number, { IdCategoria: number; Categoria: string }> = {
    6: { IdCategoria: 6, Categoria: 'Saxofones' },
    7: { IdCategoria: 7, Categoria: 'Clarinetes' },
    8: { IdCategoria: 8, Categoria: 'Flautas Transversal' },
    14: { IdCategoria: 14, Categoria: 'Trompetas' },
    15: { IdCategoria: 15, Categoria: 'Trombones' },
    111: { IdCategoria: 111, Categoria: 'Cañas Dobles' }
  };

  constructor(
    protected ProdServ: ProductosServicesService,
    public router: Router,
    private seo: SeoService,
    @Inject(PLATFORM_ID) private platformId: object

  ) { }

  async ngOnInit() {
    this.seo.update({
      title: 'Clave Winds | Instrumentos musicales de viento',
      description: 'Compra instrumentos musicales de viento, accesorios, boquillas, cañas, refacciones y productos especializados.',
      canonical: this.seo.absoluteUrl('/'),
      jsonLd: [
        {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Clave Winds',
          url: this.seo.absoluteUrl('/'),
          logo: this.seo.absoluteUrl('/Public/Img/LogoFoot.png'),
          email: 'ventas@clavemusica.com.mx',
          telephone: '+52 492 922 9639',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Juan de Tolosa 1106, Centro',
            postalCode: '98000',
            addressLocality: 'Zacatecas',
            addressCountry: 'MX'
          },
          sameAs: [
            'https://www.instagram.com/claveinstrumentosmusica',
            'https://www.facebook.com/239591079577745',
            'https://www.tiktok.com/@clavetreto'
          ]
        },
        {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: this.faqItems.map(item => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answer
            }
          }))
        }
      ]
    });
    await Promise.all([
      this.GetProductosRecomendados(),
      this.GetProductosNovedosos()
    ]);
  }

  async GetProductosNovedosos(){
    this.lsProdNov = await this.ProdServ.GetProductos(0,1);
  }

  async GetProductosRecomendados(){
    this.lsProdRec = await this.ProdServ.GetProductos(0,2);
  }

  public detalleProducto(prod:any){
    const id = productId(prod);
    if (this.isBrowser) safeSessionStorage.setItem('IdProd', JSON.stringify(id));
    this.router.navigateByUrl(productPath(prod));
  }

  VentanaProductos(IdCategoria:number){
    this.router.navigateByUrl(this.categoryPath(IdCategoria));
  }

  public productPath(prod: any): string {
    return productPath(prod);
  }

  public productImageUrl(prod: any): string {
    const rawPath = String(prod?.Modelos?.[0]?.Imagenes?.[0]?.Img ?? '').trim();
    const path = rawPath || 'Public/Img/Productos/Default.jpg';

    if (/^https?:\/\//i.test(path)) return path;

    const normalizedPath = path
      .replace(/^\/+/, '')
      .replace(/^api\//i, '');

    return new URL(normalizedPath, environment.mediaUrl).toString();
  }

  public categoryPath(id: number): string {
    return categoryPath(this.categoryLinks[id] ?? id);
  }

  private get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }
  

}
